/**
 * [课程类型弹窗]
 * @author: Fu Xiaochun
 * @date: 2021-08-24 
 */

import React, { useState, useEffect } from 'react';
import styles from './LessionTypeModal.module.scss';
import PropTypes from 'prop-types';
import { Modal, Input, message,  } from 'antd';
import * as api from '@/apis/client/school';

function LessionTypeModal(props){

    const title = props.lessionTypeInfo.id ? '编辑课程类型' : '新建课程类型';
    const [name, setName] = useState(props.lessionTypeInfo.name || '');
    const [studyPurpose, setStudyPurpose] = useState(props.lessionTypeInfo.studyPurpose || '');
    const [msg, setMsg] = useState({});

    const onNameChange = (e)=>{
        let val = e.target.value.trim();
        setName(val);
        if(val){
            setMsg({...msg, name: ''});
        }
    };

    const onStudyPurposeChange = (e)=>{
        let val = e.target.value.trim();
        setStudyPurpose(val);
        if(val){
            setMsg({...msg, studyPurpose: ''});
        }
    };

    const validate = ()=>{
        let status = true;
        let tips = {...msg};
        if(name.length == 0){
            status = false;
            tips.name = '请输入课程类型';
        }else if(name.length > 6){
            status = false;
            tips.name = '不得超过6字符';
        }else{
            tips.name = '';
        }

        if(studyPurpose.length == 0){
            status = false;
            tips.studyPurpose = '请输入学习目的';
        }else if(studyPurpose.length > 20){
            status = false;
            tips.studyPurpose = '不得超过20字符';
        }else{
            tips.studyPurpose = '';
        }

        setMsg(tips);
        return status;
    };

    const onSave = ()=>{
        let id = props.lessionTypeInfo.id;
        if(!validate()){
            return false;     
        }
        if(id){
            api.updateClass({id, name, studyPurpose}).then(res=>{
                message.success('修改成功');
                props.onOk();
            }).catch(err=>{
                message.error(err.message);
            });
        }else{
            api.addClass({name, studyPurpose}).then(res=>{
                message.success('创建成功');
                props.onOk();
            }).catch(err=>{
                message.error(err.message);
            });
        }
        
    };

    const onCancel = ()=>{
        props.onClose();
    };

    return (
        <Modal
            title={title}
            centered={true}
            visible={true}
            onOk={onSave}
            onCancel={onCancel}
            okText="确认"
            cancelText="取消"
        >
            <div className={styles.formBox}>
                <div className={styles.formItem}>
                    <div className={styles.label}><span>*</span>课程类型：</div>
                    <div className={styles.info}>
                        <Input className={styles.txt} value={name} onChange={onNameChange} />
                        <p>{msg.name ? <i>!</i> : null}{msg.name}</p>
                    </div>
                </div>
                <div className={styles.formItem}>
                    <div className={styles.label}><span>*</span>学习目的：</div>
                    <div className={styles.info}>
                        <Input.TextArea className={styles.txts} value={studyPurpose} onChange={onStudyPurposeChange}/>
                        <p>{msg.studyPurpose ? <i>!</i> : null}{msg.studyPurpose}</p>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

LessionTypeModal.defaultProps = {
    lessionTypeInfo: {
        id: 0,
        name: '',
        studyPurpose: ''
    }
};
LessionTypeModal.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    lessionTypeInfo: PropTypes.object,
    onOk: PropTypes.func,
    onClose: PropTypes.func
};

export default LessionTypeModal;